import FaceIcon from '@material-ui/icons/Face';
import HomeIcon from '@material-ui/icons/Home';

export const rafflesiaDrawerRoutes = [
  {
    id: 'first-section',
    routes: [
      {
        path: '/',
        labelId: 'rafflesia.home.drawer',
        Icon: HomeIcon,
      },
      {
        path: '/friends',
        labelId: 'rafflesia.friends.drawer',
        Icon: FaceIcon,
      },
    ],
  },
];

export const rafflesiaBottomNavMenus = [
  {
    path: '/',
    labelId: 'rafflesia.home.drawer',
    Icon: HomeIcon,
  },
  {
    path: '/friends',
    labelId: 'rafflesia.friends.drawer',
    Icon: FaceIcon,
  },
  {
    type: 'account',
    labelId: 'rafflesia.menu.account',
  }
];
